export const paths = [
    {
        old: 'articles/detail/tanda-tanda-hamil',
        new: 'articles/detail/tanda-tanda-hamil-yang-mungkin-tidak-disadari'
    },
    {
        old: 'articles/detail/tanda-tanda-hamil-yang-mungkin-tidak-disadari',
        new: 'articles/detail/tanda-tanda-hamil-beberapa-mungkin-tidak-disadari'
    },
];